// export const API_URL='https://api.collectapi.com/corona'
// export const API_TOKEN='apikey 4dqx4YFwS6svYFghsKWUlO:5kNWc757ehPOUA8hSS4Twt'


export const API_URL='https://api.collectapi.com/corona/'
export const API_TOKEN='apikey 4x5Y1EbILDs96m79dj3i0T:7D9ziudsDDUMmPNZdPRBPS'
